import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllTrades = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.TradeAPI}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getTradeById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.TradeAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertTrade = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.TradeAPI, input);
  return data;
};

const updateTrade = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.TradeAPI, input);
  return data;
};

const deleteTrade = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.TradeAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetTradesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.TradeAPI],
    queryFn: () => getAllTrades(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetTradeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.TradeAPI],
    queryFn: () => getTradeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertTradeMutation = () => {
  return useMutation({
    mutationFn: insertTrade,
  });
};

export const useUpdateTradeMutation = () => {
  return useMutation({
    mutationFn: updateTrade,
  });
};

export const useDeleteTradeMutation = () => {
  return useMutation({
    mutationFn: deleteTrade,
  });
};
